import * as Yup from "yup";

export const initialValues = {
  code: null,
  name: null,
  nameEn: null,
  rounding: null,
  frequencyOfPayment: null,
  incomeType: null,
};

const DeductionSchema = Yup.object().shape({
  code: Yup.string().required("Please enter."),
  name: Yup.string().required("Please enter."),
  nameEn: Yup.string().required("Please enter."),
  rounding: Yup.string().required("Please select."),
  frequencyOfPayment: Yup.string().required("Please select."),
  incomeType: Yup.string().required("Please select."),
});

export default DeductionSchema;
